export default function ErrorMessages({ openMessageError, finishOrder }) {
  if (!openMessageError && finishOrder !== "error") return null;

  return (
    <>
      {openMessageError && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #d32f2f",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "24px",
            backgroundColor: "#ffebee",
          }}
        >
          <span style={{ color: "#d32f2f", marginRight: "16px" }}>⚠️</span>
          <div>
            <p style={{ fontWeight: "bold", color: "#d32f2f" }}>
              Não foram localizados produtos na Vitrine Virtual.
            </p>
            <p style={{ color: "#d32f2f" }}>
              Entre em contato com o lojista.
            </p>
          </div>
        </div>
      )}

      {finishOrder === "error" && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #d32f2f",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "24px",
            backgroundColor: "#ffebee",
          }}
        >
          <span style={{ color: "#d32f2f", marginRight: "16px" }}>⚠️</span>
          <div>
            <p style={{ fontWeight: "bold", color: "#d32f2f" }}>
              Ocorreu um problema na finalização do seu carrinho.
            </p>
            <p style={{ color: "#d32f2f" }}>
              Entre em contato com o lojista.
            </p>
          </div>
        </div>
      )}
    </>
  );
}

